<template>
  <div :id="componentId" class="sp1-address-section" :style="sectionStyle">
    <div class="address-content flex-row">
      <div class="address-image-wrapper">
        <img
          class="address-image"
          referrerpolicy="no-referrer"
          :src="address.image"
        />
        <div class="address-name-bar flex-col">
          <span class="address-name">{{ address.name }}</span>
        </div>
      </div>
      <img
        class="map-image"
        referrerpolicy="no-referrer"
        :src="address.map"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_8'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      address: {
        name: '北京市朝阳区XXX酒店',
        image: require('../assets/img/address_hotel.png'),
        map: require('../assets/img/address_map.png')
      }
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
        padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  }
};
</script>

<style scoped>
.sp1-address-section {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 39px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.address-content {
  width: 1400px;
  height: 380px;
}

.address-image-wrapper {
  position: relative;
  width: 1031px;
  height: 380px;
}

.address-image {
  width: 1031px;
  height: 380px;
}

.address-name-bar {
  position: absolute;
  left: 0;
  top: 0;
  width: 1032px;
  height: 58px;
  background-image: linear-gradient(
    90deg,
    rgba(43, 131, 120, 1) 0,
    rgba(48, 133, 122, 0) 100%
  );
  justify-content: center;
}

.address-name {
  width: 199px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 26px;
}

.map-image {
  width: 369px;
  height: 380px;
}
</style>
